import style from './AddNewItem.module.css';
import FormComp from '../../FormComp';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getItensByNorma } from '../../../Funcoes/GetItensByNorma';
import { ImSpinner8 } from "react-icons/im";
import { toast } from 'react-toastify';
import useApi from '../../../hooks/useApi';
import MultiFileUploader from '../../Utils/MultiFileUploader';
import Overlay from '../../Overlay';
import Modal from '../../Utils/Modal';
import { useModal } from '../../../contexts/ModalContext';

const ModalTitle = styled.h3`
    margin: 0 0 18px 0;
    padding: 0 0 12px 2px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 15px;
    font-weight: 700;
    color: #263b4b;
    letter-spacing: 0.02em;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
`;

const NormaActionsRow = styled.div`
    display: flex;
    gap: 6px;
    margin-top: 15px;
    margin-bottom: 8px;
    width: 100%;
`;

const NormaActionButton = styled.button`
    flex: 1;
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 10px;
    outline: none;
    box-sizing: border-box;
    background-color: ${(p) => (p.$danger ? '#b91c1c' : '#4caf50')};
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$danger ? '#991b1b' : '#45a049')};
    }

    &:disabled {
        background-color: #c1c1c1;
        color: #fff;
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid ${(p) => (p.$danger ? '#b91c1c' : '#4caf50')};
        outline-offset: 2px;
    }
`;

const AddNewItem = ({ auditoria, updateItens }) => {

    const api = useApi();
    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true)

    const [lideres, setLideres] = useState([])
    const setores = [
        "ADM",
        "ALMOXARIFADO/MATERIAIS",
        "ALTA DIREÇÃO",
        "ANDAIMES",
        "COMERCIAL",
        "CONTABILIDADE",
        "CONTROLE DE OBRAS",
        "ELÉTRICA",
        "ENGENHARIA E ORÇAMENTOS",
        "FABRICAÇÃO (PIPE SHOP)",
        "FINANCEIRO",
        "FISCAL",
        "IÇAMENTO E MOVIMENTAÇÃO DE CARGA",
        "INSTRUMENTAÇÃO",
        "ISOLAMENTO TÉRMICO",
        "JURÍDICO",
        "LOGÍSTICA",
        "MANUTENÇÃO MECÂNICA",
        "MECÂNICA",
        "PINTURA",
        "PLANEJAMENTO/GERENCIAMENTO DE OBRAS",
        "QUALIDADE",
        "RECURSOS HUMANOS",
        "SGI - SISTEMA DE GESTÃO INTEGRADO",
        "SSMA",
        "SUPRIMENTOS",
        "T.I.",
        "TUBULAÇÃO"
    ]

    const getLideres = async () => {

        try {

            const { data } = await api.get('/Painel/assets/php/getLideres.php')
            setLideres(data.map(obj => obj.RA_NOMECMP))

        } catch (error) {

            console.log(error)

        }

    }

    useEffect(() => {

        const getInitialValues = async () => {

            await getLideres();
            setLoading( false );

        }

        getInitialValues();

    }, [])

    const [formValues, setFormValues] = useState({
        auditoria: auditoria,
        auditado: '',
        normas: [{ norma: '', item: '' }],
        setor: '',
        conformidade: '',
        fato: '',
        evidencia: ''
    })

    const [ selectedFiles, setFiles ] = useState([])

    const handleChange = (e, index, field) => {

        const { name, value } = e.target

        if (field === 'normas') {

            const updatedNormas = [...formValues.normas]    //Busca os valores atuais dos itens e coloca em uma const
            updatedNormas[index][name] = value            //Seleciona o item que foi chamado de acordo com o index e altera o valor

            if (name === 'norma') {

                updatedNormas[index]["item"] = ''           //Limpa o item caso a norma seja alterada

            }

            setFormValues({
                ...formValues,
                normas: updatedNormas
            })

        } else {

            if ( name === 'conformidade' && ( value === 'C' || value === 'NA' ) ){

                setFormValues({
                    ...formValues,
                    fato: '',
                    [name]: value
                });

            } else {

                setFormValues({
                    ...formValues,
                    [name]: value
                });

            }

        }

    }

    const addNormaItem = () => {

        setFormValues({
            ...formValues,
            normas: [...formValues.normas, { norma: '', item: '' }]
        })

    }

    const removeNormaItem = () => {

        const updatedNormas = [...formValues.normas]
        updatedNormas.pop();
        setFormValues({ ...formValues, normas: updatedNormas })

    }

    const [ disabledForm, setDisabledForm ] = useState( false )

    const handleSubmit = async ( e ) => {

        e.preventDefault();
        setDisabledForm( true );

        const formData = new FormData();
        for( const key in formValues ){

            if( key === 'normas' ){

                formData.append( key, JSON.stringify( formValues[ key ] ) )

            }else{

                formData.append( key, formValues[ key ] );

            }

        }

        if( selectedFiles ){

            selectedFiles.forEach(( item ) => {

                formData.append( 'files[]', item.file )

            })

        }

        try{

            const { data } = await api.post('/Painel/API/AuditInterna/SaveItem/', formData);
            console.log( data );

            await updateItens();
            closeModal();

        }catch( error ){

            console.log( error );
            toast.error( error.response.data.message );

        }finally{

            setDisabledForm( false );

        }

    }

    return (
        <Overlay state>
            <Modal header close={closeModal} size="md">
                <ModalTitle>REGISTRAR NOVO ITEM</ModalTitle>
                {
                    loading ?
                        <div className={style.loadingContainer} >
                            <div className={ style.loadingBox } >
                                <p className={ style.loadingTxt } >CARREGANDO</p>
                                <div className={ style.spinnerContainer } >
                                    <ImSpinner8 className={ style.spinnerIcon } />
                                </div>
                            </div>
                        </div>
                    :
                        <form
                            className={style.formulario}
                            onSubmit={ handleSubmit }
                        >
                            <FormComp
                                title="AUDITADO"
                                type="select"
                                options={lideres}
                                name="auditado"
                                valor={formValues.auditado}
                                changeFunc={(e) => handleChange(e)}
                                required
                            />

                            {
                                formValues.normas.map((normaItem, index) => (

                                    <div key={index} className={style.normaItem} >
                                        <p className={style.normaItemTitle} >NORMA | ITEM</p>
                                        <FormComp
                                            type="select"
                                            options={[
                                                'ISO 9001:2015',
                                                'ISO 14001:2015',
                                                'ISO 45001:2018'
                                            ]}
                                            name="norma"
                                            valor={normaItem.norma}
                                            changeFunc={(e) => handleChange(e, index, "normas")}
                                            required
                                        />
                                        <FormComp
                                            type="select"
                                            options={getItensByNorma(normaItem.norma)}
                                            name="item"
                                            valor={normaItem.item}
                                            changeFunc={(e) => handleChange(e, index, "normas")}
                                            required
                                        />
                                    </ div>

                                ))
                            }

                            <NormaActionsRow>
                                <NormaActionButton
                                    type="button"
                                    onClick={addNormaItem}
                                    disabled={formValues.normas.length >= 4}
                                >
                                    ADICIONAR ITEM
                                </NormaActionButton>
                                <NormaActionButton
                                    type="button"
                                    $danger
                                    onClick={removeNormaItem}
                                    disabled={formValues.normas.length <= 1}
                                >
                                    REMOVER ITEM
                                </NormaActionButton>
                            </NormaActionsRow>


                            <FormComp
                                title="SETOR"
                                type="select"
                                options={setores}
                                name="setor"
                                valor={formValues.setor}
                                changeFunc={(e) => handleChange(e)}
                                required
                            />
                            <FormComp
                                title="CONFORMIDADE"
                                type="select"
                                options={['C', 'NC', 'NA', 'OM']}
                                name="conformidade"
                                valor={formValues.conformidade}
                                changeFunc={(e) => handleChange(e)}
                                required
                            />
                            <FormComp
                                title="EVIDÊNCIA OBJETIVA"
                                type="textarea"
                                name="evidencia"
                                valor={formValues.evidencia}
                                changeFunc={(e) => handleChange(e)}
                                required
                            />
                            {
                                ( formValues.conformidade === 'NC' || formValues.conformidade === 'OM' ) && (
                                    <FormComp
                                        title="FATO"
                                        type="textarea"
                                        name="fato"
                                        valor={ formValues.fato }
                                        changeFunc={(e) => handleChange(e) }
                                        required
                                    />
                                )
                            }
                            <p className={style.normaItemTitle}>ANEXOS</p>
                            <MultiFileUploader
                                files={selectedFiles}
                                setFiles={setFiles}
                                accept="*"
                            />
                            <FormComp
                                type="submit"
                                valor={ disabledForm ? 'AGUARDE' : 'SALVAR' }
                                disabled={ disabledForm }
                            />
                        </form>
                }
            </Modal>
        </Overlay>
    )

}

export default AddNewItem;